/* istanbul ignore file */

import { Image } from '@lumapps/wrex-image/components/blocks/Image';
import { Link } from '@lumapps/wrex-link/components/blocks/Link';
import { LINK } from '@lumapps/wrex-link/constants';
import { ListItem } from '@lumapps/wrex-list/components/blocks/ListItem';
import { OrderedList } from '@lumapps/wrex-list/components/blocks/OrderedList';
import { UnorderedList } from '@lumapps/wrex-list/components/blocks/UnorderedList';
import { ORDERED_LIST, UNORDERED_LIST } from '@lumapps/wrex-list/constants';
import { QuoteBlock } from '@lumapps/wrex-quote/components/blocks/QuoteBlock';
import { Table, TH, TR, TD } from '@lumapps/wrex-table/components/blocks';
import { CodeBlock } from '@lumapps/wrex-typography/components/blocks/CodeBlock';
import { Headline } from '@lumapps/wrex-typography/components/blocks/Headline';
import { HR } from '@lumapps/wrex-typography/components/blocks/HR';
import { Bold, Italic, Strikethrough, Underline } from '@lumapps/wrex-typography/components/blocks/Mark';
import { Paragraph } from '@lumapps/wrex-typography/components/blocks/Paragraph';
import { Subtitle } from '@lumapps/wrex-typography/components/blocks/Subtitle';
import { Title } from '@lumapps/wrex-typography/components/blocks/Title';
import {
    ALIGN_CENTER,
    ALIGN_END,
    ALIGN_START,
    BOLD,
    INLINE_CODE,
    ITALIC,
    REDO,
    STRIKETHROUGH,
    UNDERLINE,
    UNDO,
} from '@lumapps/wrex-typography/constants';
import { UserMention } from '@lumapps/wrex-user-mention/components/blocks/UserMention';

import { formatShortcut } from './utils/formatShortcut';

/**
 * Exhaustive list of rendered elements in post content.
 */
export const ELEMENTS = [
    Paragraph,
    Headline,
    Title,
    Subtitle,
    Link,
    Image,
    UnorderedList,
    OrderedList,
    ListItem,
    Table,
    TH,
    TR,
    TD,
    QuoteBlock,
    HR,
    UserMention,
    CodeBlock,
];

/**
 * Exhaustive list of rendered mark in post content
 */
export const MARKS = [Bold, Italic, Underline, Strikethrough];

/**
 * List of element type that will be translated with google translate
 */
export const ELEMENT_TYPE_TO_TRANSLATE = ['text', 'og:description'];

/**
 * List of element type that will not be translated with google translate
 */
export const ELEMENT_TYPE_TO_NOT_TRANSLATE = ['lumapps:user'];

/**
 * Command keys for shortcuts
 */
export const PLUGIN_SHORTCUTS = {
    [BOLD]: { hotkey: 'mod+b', shortcut: formatShortcut(true, 'B') },
    [ITALIC]: { hotkey: 'mod+i', shortcut: formatShortcut(true, 'I') },
    [UNORDERED_LIST]: { hotkey: 'mod+shift+8', shortcut: formatShortcut(false, 'Shift+8') },
    [ORDERED_LIST]: { hotkey: 'mod+shift+7', shortcut: formatShortcut(false, 'Shift+7') },
    [LINK]: { hotkey: 'mod+k', shortcut: formatShortcut(true, 'K') },
    [UNDO]: { hotkey: 'mod+z', shortcut: formatShortcut(true, 'Z') },
    [REDO]: { hotkey: 'mod+y', shortcut: formatShortcut(true, 'Y') },
    [INLINE_CODE]: { hotkey: 'mod+shift+c', shortcut: undefined },
    [UNDERLINE]: { hotkey: 'mod+u', shortcut: formatShortcut(true, 'U') },
    [STRIKETHROUGH]: { hotkey: 'mod+shift+x', shortcut: formatShortcut(false, 'Shift+X') },
    [ALIGN_START]: { hotkey: 'mod+shift+l', shortcut: formatShortcut(false, 'Shift+L') },
    [ALIGN_CENTER]: { hotkey: 'mod+shift+e', shortcut: formatShortcut(false, 'Shift+E') },
    [ALIGN_END]: { hotkey: 'mod+shift+r', shortcut: formatShortcut(false, 'Shift+R') },
};
